import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Spin, Descriptions, Layout, Alert } from 'antd';
import './FileManagerPOA.css';
import config from '../../config';
import ProyectEstructurado from '../ProyectoEstructurado/HomePage';
const baseUrl = config.baseUrl;

const FileManagerPOA = (codigo_tarea) => {
    const [treeData, setTreeData] = useState([]);
    const [, settreeFilesData] = useState([]);
    const tmpCodigo = String(codigo_tarea.codigo_tarea.codigo_tarea).replace(/\./g, '');
    const codigo_proyecto_busqueda = 'tarea_' + tmpCodigo;
    const [loading, setLoading] = useState(true);
    const [expandAll,] = useState(true);
    const [, settituloNameProyecto] = useState('');
    const nameproyecto = "Tarea POA";
    const [showWarning, setShowWarning] = useState(false);
    const [, setProyectos] = useState([]);
    const inputRef = useRef(null);


    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (!codigo_proyecto_busqueda) {
                setLoading(false);
                setShowWarning(true);
                settituloNameProyecto("FAO - UTF COL 160 COL")
                return;
            }
            settituloNameProyecto(`${codigo_proyecto_busqueda} ${nameproyecto}`);
            try {
                const tmpcodActividadParametro = String(codigo_tarea.codigo_tarea.codActividad).replace(/\./g, '');
                const codActividadParametro = 'actividad_' + tmpcodActividadParametro;
                const response = await axios.get(`${baseUrl}/api/directorytreepoa?codigActividad=${codActividadParametro}&codigoTarea=${codigo_proyecto_busqueda}`);
                const data = response.data;
                const indicador = codigo_tarea.codigo_tarea.key;
                const getIndicadorChildren = (nodes) => {
                    return nodes.flatMap(node => {
                        if (node.typeS === 'indicador' && node.name === indicador) {
                            return node.children;
                        } else if (node.children && node.children.length > 0) {
                            return getIndicadorChildren(node.children);
                        }
                        return [];
                    });
                };
                const filteredData = getIndicadorChildren(data);
                const filterLimitData = limitChildrenToThreeLevels(filteredData);
                setTreeData(filterLimitData);
            } catch (error) {
                console.error('Error fetching file tree:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [codigo_proyecto_busqueda, expandAll]);


    const limitChildrenToThreeLevels = (data, level = 1) => {
        return data.map(item => {
            const newItem = { ...item };
            if (level < 3 && newItem.children && newItem.children.length > 0) {
                newItem.children = limitChildrenToThreeLevels(newItem.children, level + 1);
            } else {
                delete newItem.children;
            }
            return newItem;
        });
    };

    useEffect(() => {
        const fetchProyectos = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${baseUrl}/api/arbolProyectos`);
                const data = response.data.data;
                setProyectos(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching proyectos:', error);
                setLoading(false);
            }
        };

        fetchProyectos();
    }, [codigo_tarea, setLoading]);


    useEffect(() => {
        if (treeData.length > 0) {
            const emptyFolders = filterEmptyFolders(treeData);
            settreeFilesData(emptyFolders);
        }
    }, [treeData]);

    const filterEmptyFolders = (treeData) => {
        const isEmptyFinalFolder = (node) => {
            if (node.type !== 'folder') {
                return false;
            }
            if (!node.children || node.children.length === 0) {
                return true;
            }
            const allSubfoldersEmpty = node.children.every(child => isEmptyFinalFolder(child));
            return allSubfoldersEmpty;
        };
        const filterTree = (nodes) => {
            return nodes
                .map(node => {
                    const filteredChildren = node.children ? filterTree(node.children) : [];
                    if (node.type === 'folder') {
                        const shouldKeep = isEmptyFinalFolder(node) || filteredChildren.length > 0;
                        return shouldKeep ? { ...node, children: filteredChildren } : null;
                    }
                    return null;
                })
                .filter(node => node !== null);
        };
        const filteredTreeData = filterTree(treeData);
        return filteredTreeData;
    };

    const { codActividad, nameActividad, codigo_tarea: codigoTarea, tarea, indicador, medioV } = codigo_tarea.codigo_tarea;
    const medioVerificacion = medioV?.[0]?.medioVerificacion || 'No disponible';

    return (
        <Layout>
            {showWarning && (
                <Alert
                    message="Advertencia"
                    description="Debe seleccionar un código de tarea para ver los medios de verificación."
                    type="warning"
                    showIcon
                    className="mb-3"
                />
            )}
            {loading ? (
                <div className="text-center">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="container-fluid py-0 my-2" style={{ marginBottom: '10px !important' }}>
                    <Descriptions bordered column={1} style={{ padding: '0 0 0 10px !important' }}>
                        <Descriptions.Item label="Actividad">
                            {codActividad} - {nameActividad}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tarea">
                            {codigoTarea} - {tarea}
                        </Descriptions.Item>
                        <Descriptions.Item label="Indicador">
                            {indicador}
                        </Descriptions.Item>
                        <Descriptions.Item label="Medio de verificación">
                                {medioVerificacion}
                        </Descriptions.Item>
                    </Descriptions>
                    <ProyectEstructurado  codigo_tarea={codigo_tarea} />


                </div >
            )}
        </Layout >
    );
};

export default FileManagerPOA;
